export default __webpack_public_path__ + "static/media/heroBG.76f7b724.png";